import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  Input, NgZone, ElementRef, ViewChild, AfterViewInit,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd';
import { UploaderComponent } from 'src/app/shared/uploader';
import {debounceTime, distinctUntilChanged, map, takeUntil} from 'rxjs/operators';
import {combineLatest, Subject} from 'rxjs';

import {
  ShopsService,
  GoongService,
  RootService,
  ProductsStoresService,
} from 'src/app/services';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import {MapsAPILoader, MouseEvent} from '@agm/core';

import {
  capitalizeFirstLetter,
  removeAllSpacingBetweenWords,
} from 'src/app/helpers';
import {ActivatedRoute} from '@angular/router';
import {ResultSearchGoogleDto} from './DTO/result-search-google.dto';
import {recursiveForm} from '../../../business/products/helper/recursive-form.helper';

// tslint:disable-next-line:class-name
interface marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
}

@Component({
  selector: 'app-create-stores',
  templateUrl: './create-stores.component.html',
  styleUrls: ['./create-stores.component.scss'],
})
export class CreateStoresComponent implements OnInit, OnDestroy, AfterViewInit {

  constructor(
    private fb: FormBuilder,
    private modalService: NzModalService,
    private shopService: ShopsService,
    private goong: GoongService,
    private rootService: RootService,
    private notification: NzNotificationService,
    private shopService2: ProductsStoresService,
    private activatedRoute: ActivatedRoute,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) {}

  title = 'AGM project';
  latitude: number;
  longitude: number;
  zoom: number;
  address1: string;
  address2: string;
  status = ''
  private geoCoder;

  @ViewChild('search1' , {static: true}) public searchElementRef: ElementRef;
  @ViewChild('search2' , {static: true}) public searchElementRef2: ElementRef;
  @ViewChild('search3' , {static: true}) public searchElementRef3: ElementRef;
  @ViewChild('search4' , {static: true}) public searchElementRef4: ElementRef;
  isVisible = false;
  shopId: string;
  productShopId: string;
  isDisable = false;
  nameShop = ''
  phoneNumberLength = ''
  addressText = '';
  addressTextNew = '';
  emailText = ''
  @Input() type: string;

  @Output() createStores = new EventEmitter<any>();
  @Output() updateStores = new EventEmitter<any>();

  unsubscribe$ = new Subject<void>();
  addressDisplay = '';
  form = this.fb.group({
    logo: [null],
    cover: [null],
    shopName: [null, [Validators.required, Validators.maxLength(255)]],
    phoneNumber: [
      null,
      [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern('[0-9]*'),
      ],
    ],
    email: [
      null,
      [
        Validators.maxLength(255),
        Validators.pattern(
          '^[a-z0-9_\\.]{1,32}@[a-z0-9]{2,}(\\.[a-z0-9]{2,4}){1,2}$'
        ),
      ],
    ],
    country_id: [1],
    province_id: [null, [Validators.required]],
    district_id: [null, [Validators.required]],
    village_id: [null, [Validators.required]],
    address: [null, [Validators.required, Validators.maxLength(255)]],
    addressNewName: [null, [Validators.maxLength(255)]],
    provinceNewId: [null, [Validators.required]],
    wardNewId: [null, [Validators.required]],
    addressNew: [true],
    lat: [null],
    lon: [null],
    titleId: [null]
  });
  cityNew = [];
  listWard = [];

  ngOnInit() {

    if (this.type === 'createShopProduct') {
      this.form.addControl(
        'titleId',
        this.fb.control(null, [Validators.required])
      );
      this.loadTitle();
      this.productId = this.activatedRoute.snapshot.paramMap.get('id');
      this.isVisible = true;
    }
    this.notification.config({
      nzPlacement: 'bottomRight',
    });
    this.loadCities();

    this.form.get('addressNew').valueChanges
      .subscribe(addressNew => {
        console.log('addressNew hẹ hẹ', addressNew);
        this.updateAddressValidation(this.form.get('addressNew').value);
      });

    // Chỉ log khi cả 3 giá trị province_id, district_id, address đều có
    combineLatest([
      this.form.get('province_id').valueChanges,
      this.form.get('district_id').valueChanges,
      this.form.get('village_id').valueChanges,
      this.form.get('address').valueChanges,
    ])
      .pipe(
        debounceTime(1500), // 👈 đợi 0.5s sau khi người dùng ngừng nhập/chọn
        distinctUntilChanged(), // 👈 chỉ gọi lại nếu giá trị thực sự thay đổi
        takeUntil(this.unsubscribe$)
      )
      .subscribe(([provinceId, districtId, village_id, address]) => {
        if (provinceId && districtId && address && this.latitude && this.longitude) {
          this.getAddress1(this.latitude, this.longitude, (address2) => {
            if (provinceId && districtId && address) {
              const query = {
                type: 1,
                parentId: 0,
                cityOldId: provinceId,
                wardOldId: village_id
              };
              this.rootService.getLocationOld(query).subscribe(res => {
                if (res.code === 1 && res.data && res.data.cityNew && res.data.cityNew.name) {
                  this.addressDisplay = [address2, res.data.wardNew.name, res.data.cityNew.name].join(', ');
                }
              });
            } else {
              this.addressDisplay = '';
            }
          });
        } else {
          this.addressDisplay = '';
        }
      });


    this.rootService.getLocationNew({
      type: 1
    }).subscribe((res) => {
      // console.log("res", res)
      this.cityNew = res.data.data;
      // console.log("this.city2", this.cityNew)
    });

    this.form.get('provinceNewId').valueChanges.pipe(debounceTime(500)).subscribe(val => {
      if (val) {
        this.rootService.getLocationNew({
          type: 2,
          parentId: val
        }).subscribe((res: any) => {
          if (res.code === 1) {
            this.listWard = res && res.data && res.data.data ?  res.data.data : [];
          }
        });
      }
    });

  }

  getDistrictsNew($event: any) {
    this.form.get('wardNewId').setValue(null);
  }

  updateAddressValidation(addressNew: boolean) {
    if (addressNew) {
      // Khi addressNew = true: bỏ required cho province_id, district_id, streetId, address
      this.form.get('province_id').clearValidators();
      this.form.get('district_id').clearValidators();
      this.form.get('village_id').clearValidators();
      this.form.get('address').clearValidators();

      // Thêm required cho addressNewName, provinceNewId, wardNewId
      this.form.get('addressNewName').setValidators([Validators.required, Validators.maxLength(255)]);
      this.form.get('provinceNewId').setValidators([Validators.required]);
      this.form.get('wardNewId').setValidators([Validators.required]);
    } else {
      // Khi addressNew = false: thêm required cho province_id, district_id, streetId, address
      this.form.get('province_id').setValidators([Validators.required]);
      this.form.get('district_id').setValidators([Validators.required]);
      this.form.get('village_id').setValidators([Validators.required]);
      this.form.get('address').setValidators([Validators.required, Validators.maxLength(255)]);

      // Bỏ required cho addressNewName, provinceNewId, wardNewId
      this.form.get('addressNewName').clearValidators();
      this.form.get('provinceNewId').clearValidators();
      this.form.get('wardNewId').clearValidators();
    }

    // Cập nhật validation cho tất cả các field
    this.form.get('province_id').updateValueAndValidity();
    this.form.get('district_id').updateValueAndValidity();
    this.form.get('village_id').updateValueAndValidity();
    this.form.get('address').updateValueAndValidity();
    this.form.get('addressNewName').updateValueAndValidity();
    this.form.get('provinceNewId').updateValueAndValidity();
    this.form.get('wardNewId').updateValueAndValidity();
  }

  titles: any = [];

  productId: string;

  cityName: string = null;
  districtName: string = null;
  wardName: string = null;
  cities: any[] = [];
  districts: any[] = [];
  wards: any[] = [];

  // ============================== Map ==============================//
  lat = 0;
  lng = 0;
  fullAddress: string;
  fullAddress2: string;
  nameAddress: string;
  lengthAddress: number;
  placeId: string;
  showSearch = true;
  isRequired = false;
  delayTimer: any;

  markers: marker[] = [
    {
      lat: this.lat,
      lng: this.lng,
      label: 'A',
      draggable: false,
    },
  ];
  // ============================== END Map ==============================//

  // ======================================================upload=====================================================//
  logos = [];
  covers = [];
  // ======================================================end upload=====================================================//

  isLoadingBtn = false;
  ngAfterViewInit(): void {
    this.mapGoogleApiLoad();

  }

  mapGoogleApiLoad = () => {
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;

      const autocomplete =  new google.maps.places.Autocomplete(this.searchElementRef.nativeElement) ;
      const autocomplete1 =  new google.maps.places.Autocomplete(this.searchElementRef2.nativeElement) ;
      const autocomplete3 =  new google.maps.places.Autocomplete(this.searchElementRef3.nativeElement) ;
      const autocomplete4 =  new google.maps.places.Autocomplete(this.searchElementRef4.nativeElement) ;
      this.handleAutocomplete(autocomplete);
      this.handleAutocomplete(autocomplete1);
      this.handleAutocomplete(autocomplete3);
      this.handleAutocomplete(autocomplete4);

    });
  }
  getChangeLocation(lat, long) {
    this.getAddress1(lat, long);
  }
  getChangeLocation2(lat, long) {
    this.getAddress2(lat, long);
  }
  handleAutocomplete(autocomplete) {
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        // get the place result
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();

        // verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }
        console.log("place", place)
        console.log("place.geometry.location.lat()", place.geometry.location.lat())
        // set latitude, longitude and zoom
        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        const provinceId = this.form.get('province_id').valueChanges;
        const districtId = this.form.get('district_id').valueChanges;
        const village_id = this.form.get('village_id').valueChanges;
        const address = this.form.get('address').valueChanges;
        this.getAddress1(this.latitude, this.longitude, (address2) => {
          if (provinceId && districtId && address) {
            const query = {
              type: 1,
              parentId: 0,
              cityOldId: provinceId,
              wardOldId: village_id
            };
            this.rootService.getLocationOld(query).subscribe(res => {
              if (res.code === 1 && res.data && res.data.cityNew && res.data.cityNew.name) {
                this.addressDisplay = [address2, res.data.wardNew.name, res.data.cityNew.name].join(', ');
              }
            });
          } else {
            this.addressDisplay = '';
          }
        });
        this.zoom = 12;
      });
    });
  }
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {

        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getAddress1(this.latitude, this.longitude);
        this.getAddress2(this.latitude, this.longitude);
      });
    }
  }

  markerDragEnd($event) {
    console.log($event);
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.getAddress1(this.latitude, this.longitude);
  }

  markerDragEnd2($event) {
    console.log($event);
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.getAddress2(this.latitude, this.longitude);
  }

  getAddress1(latitude = 0, longitude =0 , cb?) {
    if(!latitude && !longitude) {
      cb(null)
    } else
    {
      this.geoCoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
        console.log(results);
        console.log(status);
        if (status === 'OK') {
          if (results[0]) {
            this.zoom = 12;
            this.address1 = results[0].formatted_address;
            console.log("address1", this.address1)
            if(!this.form.value.address) {
              this.form.get('address').setValue( this.address1)
            }
            // if(!this.form.value.addressNewName) {
            //   this.form.get('addressNewName').setValue( this.address1)
            // }
            console.log(this.form.value)
            cb && cb(this.address1);


          } else {
            window.alert('No results found');
          }
        } else {
          window.alert('Geocoder failed due to: ' + status);
        }

      });
    }

  }

  getAddress2(latitude = 0, longitude =0 , cb?) {
    if(!latitude && !longitude) {
      cb(null)
    } else
    {
      this.geoCoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
        console.log(results);
        console.log(status);
        if (status === 'OK') {
          if (results[0]) {
            this.zoom = 12;
            this.address2 = results[0].formatted_address;
            console.log("this.address2", this.address2)
            if(!this.form.value.addressNewName) {
              this.form.get('addressNewName').setValue( this.address2);
            }
            console.log(this.form.value);
            cb && cb(this.address2);


          } else {
            window.alert('No results found');
          }
        } else {
          window.alert('Geocoder failed due to: ' + status);
        }

      });
    }

  }
  showModal(type: string, data?: any, productId?: any) {
    console.log('test open ');
    this.isDisable = false;
    this.isVisible = true;
    this.type = type;
    this.setNull();
    if (type === 'createShop') {
      this.form.get('addressNew').setValue(true);
      if (!this.form.value.address && window.navigator.geolocation) {
        this.form.get('address').setValue(this.address1);
      }
      if (!this.form.value.addressNewName && window.navigator.geolocation) {
        this.form.get('addressNewName').setValue(this.address2);
      }
      // this.form.get('addressNewName').setValue(this.address2);


    }
    if (type === 'updateShopProduct') {
      this.form.addControl(
        'titleId',
        this.fb.control(null, [Validators.required])
      );
      this.loadTitle();
      this.productShopId = data.shopId;
      this.shopService2
        .getById(data.shopId, productId)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res) => {
            if (res.code === 1) {
              this.setFormValue(res);
              return;
            }
            if (res.code !== 1) {
              this.openMessage('warning', 'Cảnh báo', `${res.message}`);
            }
          },
          (err) => {
            this.openMessage('error', 'Lỗi !!!', `${err}`);
          }
        );
      return;
    }
    if (type === 'updateShop') {


      this.shopId = data.id;
      this.shopService
        .getById(data.id)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res) => {
            if (res.code === 1) {

              // new ClickTekoDto('portal_store_list', 'update' ,'portal_store_update' , {shopName, phoneNumber})

              this.setFormValue(res);
              return;
            }
            if (res.code !== 1) {
              this.openMessage('warning', 'Cảnh báo', `${res.message}`);
            }
          },
          (err) => {
            this.openMessage('error', 'Lỗi !!!', `${err}`);
          }
        );
      return;
    }
  }

  setFormValue(data: any) {
    console.log('data shop: ', data);

    this.getDistrictByCityId(data.data.province_id);
    this.getWardByDistrictId(data.data.district_id);
    this.getWardId(data.data.village_id);

    if (data.data.logo) {
      this.logos = [{ url: data.data.logo_org }];
      this.form.get('logo').setValue(data.data.logo);
    }
    if (data.data.cover) {
      this.covers = [{ url: data.data.cover_org }];
      this.form.get('cover').setValue(data.data.cover);
    }
    this.form.get('shopName').setValue(data.data.shopName);
    this.form.get('phoneNumber').setValue(data.data.phoneNumber);
    this.form.get('email').setValue(data.data.email);
    this.form.get('country_id').setValue(1);
    this.form.get('province_id').setValue(data.data.province_id || null);
    this.form.get('district_id').setValue(data.data.district_id || null);
    this.form.get('village_id').setValue(data.data.village_id || null);
    // this.form.get('address').setValue(data.data.address.split(',').slice(0, -3).join(','));
    this.form.get('address').setValue(data.data.address);
    this.form.get('lat').setValue(Number(data.data.lat));
    this.form.get('lon').setValue(Number(data.data.lon));

    this.form.get('addressNew').setValue(data.data.address_new || false);
    this.form.get('addressNewName').setValue(data.data.address_new_name);
    this.form.get('provinceNewId').setValue(data.data.city_new_id || null);
    this.form.get('wardNewId').setValue(data.data.ward_new_id || null);

    if (
      this.type === 'createShopProduct' ||
      this.type === 'updateShopProduct'
    ) {
      this.form.get('titleId').setValue(data.data.titleId);
    }

    this.latitude = Number(data.data.lat);
    this.longitude = Number(data.data.lon);

    this.markers.push({
      lat: this.lat,
      lng: this.lng,
      draggable: true,
    });
  }

  handleCancel() {
    if(this.type === 'createShop'){


    }
    if(this.type === 'updateShop') {


    }
    this.isVisible = false;
  }

  openMessage(type: string, title: string, content: any) {
    return this.notification.create(type, title, content);
  }
  loadTitle() {
    this.shopService.getAllTitle().subscribe(
      (res) => {
        if (res.code === 1) {
          this.titles = res.data.items;
          return;
        }
        if (res.code !== 1) {
          this.openMessage('warning', 'Cảnh báo', `${res.message}`);
        }
      },
      (err) => {
        this.openMessage('error', 'Lỗi !!!', `${err}`);
      }
    );
  }

  loadCities() {
    this.rootService
      .listCities()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.cities = res.data.items;
            return;
          }
          if (res.code !== 1) {
            this.openMessage('warning', 'Cảnh báo', `${res.message}`);
          }
        },
        (err) => {
          this.openMessage('error', 'Lỗi !!!', `${err}`);
        }
      );
  }

  getDistrictByCityId(id: number) {
    this.form.get('district_id').setValue(null);
    this.form.get('village_id').setValue(null);
    this.form.get('address').setValue(null);
    this.showSearch = false;
    this.districts = [];

    if (id) {
      this.rootService
        .getCityById(id)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res: any) => {
            if (res.code === 1) {
              this.cityName = res.data.name;
              return;
            }
            if (res.code !== 1) {
              this.openMessage('warning', 'Cảnh báo', `${res.message}`);
            }
          },
          (err) => {
            this.openMessage('error', 'Lỗi !!!', `${err}`);
            return;
          }
        );

      this.rootService
        .listDistricts(id)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res: any) => {
          this.districts = res.data.items;
        });
    }


  }

  getWardByDistrictId(id: number) {
    this.form.get('village_id').setValue(null);
    this.form.get('address').setValue(null);
    this.showSearch = false;
    this.wards = [];

    if (id) {
      this.rootService
        .getDistrictById(id)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res: any) => {
            if (res.code === 1) {
              this.districtName = res.data.name;
              return;
            }
            if (res.code !== 1) {
              this.openMessage('warning', 'Cảnh báo', `${res.message}`);
            }
          },
          (err) => {
            this.openMessage('error', 'Lỗi !!!', `${err}`);
            return;
          }
        );

      this.rootService
        .listWards(id)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res: any) => {
          this.wards = res.data.items;
        });
    }
  }

  getWardId(id: number) {
    this.form.get('address').setValue(null);
    this.showSearch = false;

    if (id) {
      this.rootService
        .getWardById(id)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res: any) => {
            if (res.code === 1) {
              this.wardName = res.data.name.slice(7, res.data.name.length);
              return;
            }
            if (res.code !== 1) {
              this.openMessage('warning', 'Cảnh báo', `${res.message}`);
            }
          },
          (err) => {
            this.openMessage('error', 'Lỗi !!!', `${err}`);
            return;
          }
        );
    }
  }

  setValueChangeCity() {
    return;
    this.form.get('district_id').setValue(null);
    this.form.get('village_id').setValue(null);
    this.form.get('address').setValue(null);
    this.showSearch = false;
  }

  setValueChangeDistrict() {
    return;
    this.form.get('village_id').setValue(null);
    this.form.get('address').setValue(null);
    this.showSearch = false;
  }

  setValueChangeWard() {
    return;
    this.form.get('address').setValue(null);
    this.showSearch = false;
  }

  searchResult(res: ResultSearchGoogleDto) {
    this.placeId = res.place_id;
    if (res.place_id) {
      this.searchMap();
      console.log(res);
      this.form.get('address').setValue(res.description);
      this.showSearch = false;
    }
  }

  searchMap() {
    this.showSearch = true;
    this.fullAddress =
      removeAllSpacingBetweenWords(this.form.value.address) +
      ' ' +
      this.wardName +
      ' ' +
      this.districtName +
      ' ' +
      this.cityName;

    console.log('this.fullAddress' , this.fullAddress);
    clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(() => {
      if (this.form.value.address.length > 0 && this.wardName  && this.districtName  && this.cityName) {
        this.isRequired = false;
        this.getAddress(this.fullAddress);
      } else {
        this.isRequired = true;
        this.showSearch = false;
      }
    }, 300);
  }

  getAddress(fullAddress: string) {
    this.goong
      .getAddress(fullAddress.trim())
      .pipe(map(z => {
        return z;
      }), takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.lengthAddress = res.predictions.length;
          this.nameAddress = res.predictions;
          console.log('res',  res);
          if (res.status === 'ZERO_RESULTS') {
            this.showSearch = false;
            // this.notification.create(
            //   'error',
            //   'Có lỗi xảy ra !!!',
            //   `Địa chỉ không tồn tại vui lòng nhập địa chỉ gần đúng.`
            // );
          } else {
            if (this.placeId) {
              this.getLocation(this.placeId);
            } else {
              this.getLocation(res.predictions[0].place_id);
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getLocation(placeId: string) {
    this.goong
      .getLocation(placeId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          if (res.status === 'OK') {
            console.log('resss' , res);
            this.lat = res.result.geometry.location.lat;
            this.lng = res.result.geometry.location.lng;
            return;
          }
          if (
            res.result.geometry.location.lat === 0 &&
            res.result.geometry.location.lng === 0
          ) {
            // this.openMessage(
            //   'error',
            //   'Lỗi !!!',
            //   `Địa chỉ của bạn không có location vui lòng nhập địa chỉ khác.`
            // );
          }
        },
        (err) => {
          console.log(err);
        },
        () => {
          this.form.get('lat').setValue(this.lat);
          this.form.get('lon').setValue(this.lng);
          this.markers = [];
          this.markers.push({
            lat: this.lat,
            lng: this.lng,
            draggable: true,
          });
        }
      );
  }

  openUploadDialog(field: string) {
    const fileType = 'jpg,jpeg,png,gif,bmp';

    const modal = this.modalService.create({
      nzTitle: `Tải ảnh lên`,
      nzContent: UploaderComponent,
      nzFooter: null,
      nzComponentParams: {
        fileExt: fileType,
        multiple: true,
      },
    });
    modal.afterOpen.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      modal.getContentComponent().change.subscribe((changeParam) => {
        if (changeParam.type === 'success') {
          if (field === 'logo') {
            this.form.get('logo').setValue(changeParam.file.response.url);
            this.logos = [{ url: changeParam.file.response.url }];
          } else if (field === 'cover') {
            this.form.get('cover').setValue(changeParam.file.response.url);
            this.covers = [{ url: changeParam.file.response.url }];
          }
        }
      });
      modal
        .getContentComponent()
        .done.pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          modal.close();
        });
    });
  }

  onRemoveFile(field: string, index: number) {
    if (field === 'logo') {
      this.logos = [];
      this.form.get('logo').setValue(null);
    } else if (field === 'cover') {
      this.covers = [];
      this.form.get('cover').setValue(null);
    }
  }
  onSubmit() {
    this.isLoadingBtn = true;
    this.isDisable = true;
    // const fullAddress2 = removeAllSpacingBetweenWords(this.form.value.address);

    const newForm = { ...this.form.value };
    if( newForm.shopName) {
      newForm.shopName = capitalizeFirstLetter(
        removeAllSpacingBetweenWords(this.form.value.shopName)
      );
    }


    newForm.country_id = 1;
    console.log(1111111111)

    newForm.lat = this.latitude || 0;
    newForm.lon = this.longitude || 0;
    if (newForm.addressNew) {
      newForm.province_id = null;
      newForm.district_id = null;
      newForm.village_id = null;
      newForm.address = null;
    } else {
      newForm.provinceNewId = null;
      newForm.wardNewId = null;
      newForm.addressNewName = null;
    }
    console.log(222)
    if(this.longitude &&  this.latitude){
      this.getAddress1(this.latitude, this.longitude , (address) => {
        newForm.address = address;
        newForm.addressNewName = address;
        if (newForm.addressNew) {
          newForm.address = null;
        } else {
          newForm.addressNewName = null;
        }
        if (this.type === 'updateShopProduct') {
          this.form.addControl('shopId', this.fb.control(this.productShopId));
          newForm.shopId = this.form.controls.shopId.value;

          this.updateStores.emit(newForm);
          this.form.removeControl('shopId');
          return;
        }

        if (this.type === 'updateShop') {
          const body: any = {
            shopId: this.shopId,
            body: newForm,
          };


          this.updateStores.emit(body);
          return;
        }

        if (this.type === 'createShop') {
          console.log(111111111111111111)

          this.createStores.emit(newForm);
        }
        this.isVisible = true;
      });
    } else {
      this.isDisable = false;
      this.openMessage('error', 'Lỗi !!!', `Invalid params`);

    }

  }

  success() {
    this.isLoadingBtn = false;
  }

  setNull() {
    this.logos = [];
    this.covers = [];
    this.lat = 0;
    this.lng = 0;
    this.markers.push({
      lat: 0,
      lng: 0,
      draggable: true,
    });
    this.form.reset();
  }

  onSubmit2() {
    this.isLoadingBtn = true;
    this.isDisable = true;
    console.log('onSubmit2')
    const newForm = { ...this.form.value };
    newForm.lat = +this.latitude || 0;
    newForm.lon = +this.longitude || 0;

    if(newForm.shopName){
      newForm.shopName = capitalizeFirstLetter(
        removeAllSpacingBetweenWords(this.form.value.shopName)
      )
    }
    this.getAddress1(this.latitude, this.longitude , (address) => {
      newForm.address = address;
      newForm.addressNewName = address;
      if (newForm.addressNew) {
        newForm.address = null;
      } else {
        newForm.addressNewName = null;
      }
      newForm.country_id = 1;
      if (this.type === 'createShopProduct') {
        this.shopService2
          .create(this.productId, newForm)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res) => {
              this.isLoadingBtn = false;
              if (res.code === 1) {
                this.openMessage(
                  'success',
                  'Thành công',
                  `Thêm điểm bán thành công`
                );
                this.isVisible = true;
                this.shopService2.getActive(true);
                this.form.reset();
                this.isDisable = false;
                return;
              }
              if (res.code !== 1) {
                this.isDisable = false;
                this.openMessage('warning', 'Cảnh báo', `${res.message}`);
              }
            },
            (err) => {
              this.isDisable = false;
              this.openMessage('error', 'Lỗi !!!', `${err}`);

              return;
            }
          );
        return;
      }
    });

  }

  handleCancel2() {
    if (this.type === 'createShop') {


    }
    if (this.type === 'updateShop') {


    }
    this.shopService2.getActive(true);
    this.form.reset();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
